import { getGeolocationServiceUrl } from '@repo/dot-env/geolocation-service-url'

import type { Coordinates } from './google-maps-input.ts'
import { fetchLookup } from './lookup-result.ts'
import { normalizeReverseGeocode, reverseGeocodeSchema } from './normalize-address.ts'

/** Reverse geocodes pinned coordinates into a normalized address. */
export const getAddressForCoordinates = (
  coordinates: Coordinates,
  serviceUrl = getGeolocationServiceUrl(),
) =>
  fetchLookup(
    `${serviceUrl}/google/coords/address?q=${encodeURIComponent(`${coordinates.lat},${coordinates.lng}`)}`,
    reverseGeocodeSchema,
    body => normalizeReverseGeocode(body, coordinates),
  )
